import React from 'react'
import styled from 'styled-components';
import OpenArms from 'assets/images/jpgs/OpenArms.jpg'

const Banner = () => {
  return (
    <div>
      <BannerContainer>
        <BannerTextWrapper>
          <h1>GET TO KNOW TRUEKEEPERS</h1>
        </BannerTextWrapper>
      </BannerContainer>
      <Divider className='w-full h-[8px]'></Divider>
    </div>
  )
}

export default Banner

const BannerContainer = styled.div`
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.765) 15.08%, rgba(0, 0, 0, 0) 62.95%), url(${OpenArms});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  height: 537px;
`;
const Divider = styled.div`
  background: linear-gradient(270deg, #F57200 -94.44%, #F0CA18 108.89%);
`;
const BannerTextWrapper = styled.div`
  /* width: 50%; */
  color: white;
  position: absolute;
  bottom: 40%;
  left: 5%;
  right: 5%;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media screen and (max-width: 700px) {
    width: 80%;
  }

  h1 {
    font-weight: 800;
    font-size: 36px;
    line-height: 42px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }
`;